import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import {
  Button,
  ButtonWithSpinner,
  CardTitle,
  DeliveryMethodInfo,
  Divider,
  Drawer,
  ReturnLabelsSelector,
} from '@reveni-io/reveni-ui'

import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'

import * as Styles from './styles'

const DeliveryMethodInfoDrawer = ({
  show,
  onClose,
  deliveryMethod,
  onSelectTimeRange,
  onSelectPickupDate,
  onSave,
  updateAddress,
  provinces,
  specialConstraints,
  changeNumberOfReturnLabels,
  numberOfReturnLabels,
  maxNumberOfReturnLabels,
  addingDeliveryMethod,
}) => {
  const { t } = useTranslation()
  const { rmaInfo } = useContext(RMAContext)

  const handleSave = async () => {
    await onSave(deliveryMethod)
    onClose()
  }

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle>{t('Método de devolución')}</CardTitle>
      <Styles.Container>
        <DeliveryMethodInfo
          deliveryMethod={deliveryMethod}
          onSelectTimeRange={onSelectTimeRange}
          specialConstraints={specialConstraints}
          onSelectPickupDate={onSelectPickupDate}
          provinces={provinces}
          shippingAddress={rmaInfo?.orderInfo?.shipping_address}
          orderInfo={rmaInfo?.orderInfo}
          merchantInfo={rmaInfo?.merchantInfo}
          updateAddress={updateAddress}
        />
        <Divider />
        <ReturnLabelsSelector
          deliveryMethod={deliveryMethod}
          onChange={changeNumberOfReturnLabels}
          numberOfReturnLabels={numberOfReturnLabels}
          maxNumberOfReturnLabels={maxNumberOfReturnLabels}
        />
        <Styles.ButtonContainer>
          <ButtonWithSpinner
            onClick={handleSave}
            defaultLabel={t('Guardar')}
            loadingLabel={t('Guardando')}
            loading={addingDeliveryMethod}
            disabled={rmaInfo?.items?.length === 0 || addingDeliveryMethod}
          >
            {t('Guardar')}
          </ButtonWithSpinner>
          <Button variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
        </Styles.ButtonContainer>
      </Styles.Container>
    </Drawer>
  )
}

export default DeliveryMethodInfoDrawer
